import React from 'react';
import PropTypes from 'prop-types';
import CreateQuoteStep2Component from './CreateQuoteStep2Component';
import { makeConcealable } from '@ami/react/core';
import { ProductConfiguration } from '../../products/productConfiguration';
import { Quote } from '../../quotes/quote';
import { QuoteProductConfiguration } from '../../quotes/quoteProductConfiguration';
import { withRouter } from 'react-router-dom';

class CreateQuoteStep2Container extends React.Component {
  static propTypes = {
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
    quoteProductConfiguration: PropTypes.instanceOf(QuoteProductConfiguration)
      .isRequired,
    onQuoteUpdated: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    quote: PropTypes.instanceOf(Quote).isRequired,
    onloadSharedDocuments: PropTypes.func.isRequired,
  };

  render() {
    const {
      productConfiguration,
      quoteProductConfiguration,
      onQuoteUpdated,
      onContinue,
      onCancel,
      quote,
      onloadSharedDocuments,
    } = this.props;
    return (
      <div>
        <CreateQuoteStep2Component
          productConfiguration={productConfiguration}
          quoteProductConfiguration={quoteProductConfiguration}
          onContinue={onContinue}
          onCancel={onCancel}
          quote={quote}
          onQuoteUpdated={onQuoteUpdated}
          onloadSharedDocuments={onloadSharedDocuments}
        />
      </div>
    );
  }
}

export default withRouter(makeConcealable(CreateQuoteStep2Container));
